import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { CREATE_USER_ROLE, GET_ROLE_SETTINGS, GET_USER_LIST, GET_USER_ROLE_LIST, GET_USER_SERVICE_LIST, INSERT_ROLE_SETTINGS, UPDATE_USER_ACCOUNT_ROLE } from "../../../../Urls.js";

const initialState = {
    userList: { data: [], loader: false },
    userRoleList: { data: [], loader: false },
    userServiceList: { data: [], loader: false },
    roleAclSettings: { data: [], loader: false },
    updateRoleAclSettings: { data: {}, loader: false, successMessage: "" },
    insertRole: { data: {}, loader: false },
    updateUserRoleData: { data: {}, loader: false },
    updateUserAccountRoleData: { data: {}, loader: false }
};

export const updateUserAccountRole = createAsyncThunk(
    'app/update/userAccountRole',
    async (reqData) => {
        const response = await axios.post(UPDATE_USER_ACCOUNT_ROLE, { ...reqData });
        return response;
    }
)

export const getUserList = createAsyncThunk(
    'app/get/getUserList',
    async (userType) => {
        const response = await axios.get(GET_USER_LIST + userType);
        return response;
    }
)

export const getUserServcieList = createAsyncThunk(
    'app/get/getUserServiceList',
    async (reqData) => {
        const response = await axios.post(GET_USER_SERVICE_LIST, { ...reqData });
        return response;
    }
)

export const getUserRoleList = createAsyncThunk(
    'app/get/getUserRoleList',
    async () => {
        const response = await axios.get(GET_USER_ROLE_LIST);
        return response;
    }
);

export const createNewRole = createAsyncThunk(
    'app/get/createNewRole',
    async (roleData) => {
        const response = await axios.post(CREATE_USER_ROLE, { ...roleData });
        return response;
    }
);

export const updateUserRole = createAsyncThunk(
    'app/get/updateUserRole',
    async (roleData) => {
        const response = await axios.post(CREATE_USER_ROLE, { ...roleData });
        return response;
    }
);

export const getRoleSettings = createAsyncThunk(
    "app/get/getRoleSettings",
    async (roleId) => {
        const response = await axios.get(GET_ROLE_SETTINGS + roleId);
        return response;
    }
);

export const updateRoleSettings = createAsyncThunk(
    "app/get/updateRoleSettings",
    async (reqData) => {
        const response = await axios.post(INSERT_ROLE_SETTINGS, { ...reqData });
        return response;
    }
);

export const roleSettingSlice = createSlice({
    name: "app/roleSettingSlice",
    initialState,
    reducers: {
        addServiceTickets: (state, action) => {
            console.table(action.payload);
            console.table(state.serviceTickets[0]);
            let currentTickets = [...state.serviceTickets];
            currentTickets.push(action.payload);
            state.serviceTickets = currentTickets;
        },
        setViewServiceTicket: (state, action) => {
            state.viewServiceTiketData = action.payload;
        },
        setServiceCategories: (state, action) => {
            state.setServiceCategories = action.payload;
        },
        clearSuccessMessage: (state) => {
            state.updateRoleAclSettings.successMessage = "";
        }
    },

    extraReducers: (builder) => {
        builder

            // Update User Account
            .addCase(updateUserAccountRole.pending, state => {
                state.updateUserAccountRoleData.loader = true;
            })
            .addCase(updateUserAccountRole.fulfilled, (state, action) => {
                state.updateUserAccountRoleData.loader = false;
                state.updateUserAccountRoleData.data = action?.payload?.data?.data;
            })
            .addCase(updateUserAccountRole.rejected, state => {
                state.updateUserAccountRoleData.loader = false;
            })


            // User list
            .addCase(getUserList.pending, state => {
                state.userList.loader = true;
            })
            .addCase(getUserList.fulfilled, (state, action) => {
                state.userList.loader = false;
                state.userList.data = action?.payload?.data?.data;
            })
            .addCase(getUserList.rejected, state => {
                state.userList.loader = false;
            })


            // User Service list
            .addCase(getUserServcieList.pending, state => {
                state.userServiceList.loader = true;
            })
            .addCase(getUserServcieList.fulfilled, (state, action) => {
                state.userServiceList.loader = false;
                state.userServiceList.data = action?.payload?.data?.data;
            })
            .addCase(getUserServcieList.rejected, state => {
                state.userServiceList.loader = false;
            })


            // create a new role
            .addCase(createNewRole.pending, state => {
                state.insertRole.loader = true;
            })
            .addCase(createNewRole.fulfilled, (state, action) => {
                state.insertRole.loader = false;
                state.insertRole.data = action?.payload?.data?.data;
            })
            .addCase(createNewRole.rejected, state => {
                state.insertRole.loader = false;
            })

            // update role info
            .addCase(updateUserRole.pending, state => {
                state.updateUserRoleData.loader = true;
            })
            .addCase(updateUserRole.fulfilled, (state, action) => {
                state.updateUserRoleData.loader = false;
                state.updateUserRoleData.data = action?.payload?.data?.data;
            })
            .addCase(updateUserRole.rejected, state => {
                state.updateUserRoleData.loader = false;
            })


            // role list
            .addCase(getUserRoleList.pending, state => {
                state.userRoleList.loader = true;
            })
            .addCase(getUserRoleList.fulfilled, (state, action) => {
                state.userRoleList.loader = false;
                state.userRoleList.data = action?.payload?.data?.data;
            })
            .addCase(getUserRoleList.rejected, state => {
                state.userRoleList.loader = false;
            })

            .addCase(getRoleSettings.pending, (state) => {
                state.roleAclSettings.loader = true;
            })
            .addCase(getRoleSettings.fulfilled, (state, action) => {
                state.roleAclSettings.loader = false;
                state.roleAclSettings.data = action?.payload?.data?.data;
            })
            .addCase(getRoleSettings.rejected, (state) => {
                state.roleAclSettings.loader = false;
            })
            .addCase(updateRoleSettings.pending, (state) => {
                state.updateRoleAclSettings.loader = true;
                state.updateRoleAclSettings.successMessage = "";
            })
            .addCase(updateRoleSettings.fulfilled, (state, action) => {
                state.updateRoleAclSettings.loader = false;
                state.updateRoleAclSettings.data = action?.payload?.data?.data;
                state.updateRoleAclSettings.successMessage = "Settings updated successfully!";
            })
            .addCase(updateRoleSettings.rejected, (state) => {
                state.updateRoleAclSettings.loader = false;
                state.updateRoleAclSettings.data = [];
                state.updateRoleAclSettings.successMessage = "Failed to update settings.";
            });
    },
});

export const { addServiceTickets, setViewServiceTicket, clearSuccessMessage } = roleSettingSlice.actions;

export default roleSettingSlice.reducer;
